import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Grid,
  Container,
  Stack,
  Paper,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import CommonTable from "../../components/common/CommonTable";
import CommonFilter from "../../components/common/CommonFilter";
import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";

import TableConfig from "../../components/dashboardVideo/index/listTableContent";
import CommonResultGrid from "../../components/common/CommonResultGrid/CommonResultGrid";

export default function Component() {
  const [filterQuery, setFilterQuery] = useState([]);
  const navigate = useNavigate();

  return (
    <Container maxWidth={"lg"}>
      <CommonBreadcrumb />

      <Paper sx={{ px: 3, pb: 3, mt: 6 }} elevation={3}>
        <Grid container rowSpacing={3} columnSpacing={2}>
          <Grid item xs={12}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box>
                <CommonFilter
                  filterConfig={TableConfig.filterConfig}
                  emitQueryFn={setFilterQuery}
                />
              </Box>
              <Box>
                <Button
                  size="small"
                  variant="contained"
                  endIcon={<AddIcon />}
                  onClick={() => navigate("/dashboardVideo/create")}
                >
                  新增影片
                </Button>
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <CommonResultGrid
              filterQuery={filterQuery}
              tableConfig={TableConfig}
            />
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
